module.exports = __webpack_public_path__ + "static/media/visa.8c988006.svg";